
import React, { FC } from "react";
import { Button } from "@chakra-ui/react";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router";

export const SurveyToolbar: FC = () => {
  const navigate = useNavigate();

  return (
    <Button
      px={6}
      colorScheme='brand'
      leftIcon={<FiEdit />}
      borderRadius='full'
      onClick={() => navigate('/encuestas/crear')}
    >
      Nueva
    </Button>

  );
};
